import { PERM } from '#/config/permissions';
import RequirePermission from '#/modules/infra/auth/RequirePermission';
import SystemSettingHubPage from '#/modules/infra/pages/SystemSettingHubPage';
import CreateEditRolePage from '#/modules/infra/settings/access/pages/CreateEditRolePage';
import CreateEditUserPage from '#/modules/infra/settings/access/pages/CreateEditUserPage';
import RoleListPage from '#/modules/infra/settings/access/pages/RoleListPage';
import UserAccessPage from '#/modules/infra/settings/access/pages/UserAccessPage';
import UserListPage from '#/modules/infra/settings/access/pages/UserListPage';

export const settingRoutes = [
  {
    path: 'setting',
    handle: { title: '系統設定' },
    children: [
      {
        index: true,
        element: (
          <RequirePermission
            codes={[PERM.SYS_ACCOUNT_READ, PERM.SYS_ROLE_READ]}
            mode="any"
          >
            <SystemSettingHubPage />
          </RequirePermission>
        ),
      },
      {
        path: 'users',
        handle: { title: '帳號管理' },
        element: <RequirePermission code={PERM.SYS_ACCOUNT_READ} />,
        children: [
          {
            index: true,
            element: <UserListPage />,
          },
          {
            path: 'create',
            handle: { title: '新增帳號' },
            element: (
              <RequirePermission code={PERM.SYS_ACCOUNT_CREATE}>
                <CreateEditUserPage />
              </RequirePermission>
            ),
          },
          {
            path: ':id/edit',
            handle: { title: '編輯帳號' },
            element: <CreateEditUserPage />,
          },
        ],
      },
      {
        path: 'roles',
        handle: { title: '職務管理' },
        element: <RequirePermission code={PERM.SYS_ROLE_READ} />,
        children: [
          {
            index: true,
            element: <RoleListPage />,
          },
          {
            path: 'create',
            handle: { title: '新增角色' },
            element: (
              <RequirePermission code={PERM.SYS_ROLE_CREATE}>
                <CreateEditRolePage />
              </RequirePermission>
            ),
          },
          {
            path: ':id/edit',
            handle: { title: '編輯角色' },
            element: <CreateEditRolePage />,
          },
        ],
      },
      {
        path: 'user-access',
        handle: { title: '使用者存取' },
        element: (
          <RequirePermission
            codes={[PERM.SYS_ACCOUNT_READ, PERM.SYS_ROLE_READ]}
            mode="all"
          >
            <UserAccessPage />
          </RequirePermission>
        ),
      },
    ],
  },
];
